import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import * as animationData from '../../../media/fb-spinner.json';

const LoadingNotch = () => (
    <svg className="circle-loader" width="18" height="18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6.75"/>
    </svg>
);

const LottieLoader = (props) => {
    const {
        message, width, height, options, style, className,
    } = props;

    const animationOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
        ...options,
    };

    const defaultStyle = {
        display: 'inline-block',
        marginLeft: '1em',
        position: 'relative',
        top: '1.25em',
        ...style,
    };

    return (
        // common container ensures elements stay together on a single line as page is resized
        <div className={className}>
            <span className="loading-message h5 text-uppercase font-weight-bold">
                {message}
            </span>
            <Lottie
                options={{ ...animationOptions }}
                width={width}
                height={height}
                style={{ ...defaultStyle }}
            />
        </div>
    );
};

LottieLoader.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    style: PropTypes.object,
    options: PropTypes.object,
};

LottieLoader.defaultProps = {
    className: '',
    message: 'Loading Content...',
    style: {},
    width: 50,
    height: 50,
};

export { LoadingNotch, LottieLoader };
